import { RENOVATION_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaInteger } from '../../../utils/schema.utils';

export const schemaBaubeschreibungSanierungen = z
    .object({
        alsEigentuemerImGrundbuchEingetragen: z.string().nullish().default(null),
        besonderheitenImGrundbuch: z.string().nullish().default(null),
        sanierungen: z
            .array(
                z.object({
                    art: z.nativeEnum(RENOVATION_TYPES),
                    bezeichnung: z.string().nullish().default(null),
                    ergaenzungen: z.string().nullish().default(null),
                    jahr: schemaInteger.min(1000).max(9999).nullish().default(null),
                }),
            )
            .refine((entries) => new Set(entries.map(({ art }) => art)).size === entries.length, {
                message: 'Renovation types must be unique',
            })
            .default([]),
        teilungserklaerungVorhanden: z.boolean().nullish().default(null),
    })
    .transform((data) => ({
        ...data,
        sanierungen: data.sanierungen.map((renovation) => ({
            ...renovation,
            bezeichnung: renovation.art === RENOVATION_TYPES.ANDERE ? renovation.bezeichnung : null,
            ergaenzungen: renovation.art === RENOVATION_TYPES.ANDERE ? null : renovation.ergaenzungen,
        })),
    }));

export type SchemaBaubeschreibungSanierungen = z.infer<typeof schemaBaubeschreibungSanierungen>;
